

















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {TableEditType} from '@/enums/table';
import DeleteDialog from '@c/DeleteDialog.vue';
import DevicesEditDialog from './DevicesEditDialog.vue';

@Component({
  components: {
    DeleteDialog,
    DevicesEditDialog,
  },
})
export default class Table extends Vue {
  @Prop()
  title!: string;

  @Prop()
  headers!: DataTableHeader[];

  @Prop()
  devices!: string;

  items: any[] = [];

  model: any = null;

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  get editDialog() {
    return this.$refs.editDialog as any;
  }

  get actualHeaders() {
    const actionsSlice = [
      {
        text: 'Действия',
        value: 'actions',
        sortable: false,
        width: 90,
      },
    ];
    return [...this.headers, ...actionsSlice];
  }

  created() {
    this.items = JSON.parse(this.devices).map((x: any, index: number) => {
      const ip = typeof x == 'string' ? x : x.ip;
      const name = typeof x == 'string' ? '-' : x.name;
      return {
        index: index,
        ip: ip,
        name: name,
      };
    });
  }

  add() {
    const index = this.items.length ? this.items[this.items.length - 1].index + 1 : 0;
    this.openEditDialog(TableEditType.Add, {index: index, ip: null, name: null});
  }

  edit(item: any) {
    this.openEditDialog(TableEditType.Edit, item);
  }

  openEditDialog(actionType: TableEditType, item: any) {
    const {type, title} = this.getInitialParams(actionType);
    this.model = {...item};
    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        if (actionType == TableEditType.Add) this.items.push({...data});
        else {
          const item = this.items.find(x => x.index == data.index);
          item.ip = data.ip;
          item.name = data.name;
        }
        this.editDialog.$refs.form.reset();
        this.editDialog.close();
        this.$emit(
          'updateDevices',
          JSON.stringify(
            this.items.map(x => {
              const result = {...x};
              delete result.index;
              return result;
            }),
          ),
        );
      },
    };
    this.editDialog.open(this.model, options);
  }

  deleteItem(item: any) {
    this.deleteDialog.open(item, {
      deleteCallback: (item: any) => {
        this.items = this.items.filter((x: any) => x.index != item.index);
        this.deleteDialog.close();
        this.$emit('updateDevices', JSON.stringify(this.items.map(x => x.ip)));
      },
    });
  }

  getInitialParams(actionType: TableEditType) {
    let params;
    switch (actionType) {
      case TableEditType.Add:
        params = {
          type: 'add',
          title: 'Создание',
        };
        break;
      case TableEditType.Edit:
        params = {
          type: 'edit',
          title: 'Редактирование',
        };
        break;
    }
    return params;
  }
}
